/**
 * Copyright © 2026 Delicious AI, LLC
 */

import {
  UltraDAIZeroCropSource,
  type UltraDAIZeroReviewCropFieldsFragment,
  type UltraDAIZeroReviewCropInput,
} from '@dai/graphql'

export const buildDAIZeroReviewCropInput = (
  crop: UltraDAIZeroReviewCropFieldsFragment,
): UltraDAIZeroReviewCropInput => ({
  source: crop.source,
  cropId: crop.cropId,
  manifestUpc: crop.upc,
  expectedUpc:
    crop.source === UltraDAIZeroCropSource.MLULTRA && crop.verified === false
      ? null
      : crop.replacementUpc ?? crop.upc,
})

export const getDAIZeroReviewEligibility = (
  crops: UltraDAIZeroReviewCropFieldsFragment[],
) => {
  const hasSelection = crops.length > 0
  const allIncluded = hasSelection && crops.every(crop => !crop.excluded)
  const allAvailable = crops.every(
    crop =>
      crop.source === UltraDAIZeroCropSource.HISTORICAL ||
      crop.verified !== null,
  )

  return {
    canRelabel: allIncluded && allAvailable,
    canExclude: allIncluded && allAvailable,
    canUnverify:
      hasSelection &&
      crops.every(
        crop =>
          crop.source === UltraDAIZeroCropSource.MLULTRA &&
          !crop.excluded &&
          crop.verified === true,
      ),
    canCancelExclusion:
      hasSelection && allAvailable && crops.every(crop => crop.excluded),
    canUndoHistoricalRelabel:
      hasSelection &&
      crops.every(
        crop =>
          crop.source === UltraDAIZeroCropSource.HISTORICAL &&
          Boolean(crop.replacementUpc) &&
          !crop.excluded,
      ),
  }
}
